import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import stores from 'cd-eft/models/Stores';
import { SOSurveys } from 'cd-eft/components/SurveyEngineering/SOSurveys';
import { ElementContainer } from '../../common/ElementContainer';
import { AlignmentSummaryTable } from '../AlignmentSummaryTable';
import { AlignmentContainerVM, removeAllUnsavedAlignments } from './AlignmentContainerVM';
import { IndependentAlignment } from '../IndependentAlignment';
import { appConfig } from 'cd-eft/config/AppConfig';
import { UserLeavingWarning } from 'cd-eft/components/common/UserLeavingWarning/UserLeavingWarning';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';

const alignmentStore = stores.AppStore.alignmentDesignStore;

const AlignmentContainerComponent = (props) => {
  const vm = useRef(new AlignmentContainerVM()).current;

  useEffect(() => {
    vm.getErrors();
    return () => {
      removeAllUnsavedAlignments();
      MessageCenter.clearMessages();
    };
  }, []);

  return (
    <ElementContainer element="Alignment" store="alignmentDesignStore">
      {alignmentStore.currentTab === 'Summary' && <AlignmentSummaryTable />}

      {/* if dependent */}
      {alignmentStore.currentTab === 'Edit' &&
        alignmentStore.currentElement.type !== appConfig.hardCodes.designElementTypeIndependent && <SOSurveys />}

      {/* independent  */}
      {alignmentStore.currentTab !== 'Summary' &&
        alignmentStore.currentElement.type === appConfig.hardCodes.designElementTypeIndependent && (
          <IndependentAlignment mapView={props.mapView} setCallables={props.setCallables} />
        )}

      {/* popups  */}
      {(Boolean(alignmentStore.currentElement.name) || alignmentStore.unsavedAlignments.size > 0) &&
        stores.AppStore.designStore.hasProject() && (
        <UserLeavingWarning
          when={Boolean(alignmentStore.currentElement.name) || alignmentStore.unsavedAlignments.size > 0}
          section="Alignment Design"
          onOK={vm.userLeavingWarningOnOk}
          okText="Return"
          cancelText={
            !Boolean(alignmentStore.currentElement.name) && alignmentStore.unsavedAlignments.size > 0
              ? 'Discard copies'
              : ''
          }
          onCancel={vm.userLeavingWarningOnCancel}
          text={
            alignmentStore.currentElement.name
              ? vm.notification.openAlignment
              : alignmentStore.unsavedAlignments.size > 0
                ? vm.notification.unsavedCopies
                : ''
          }
        />
      )}
    </ElementContainer>
  );
};

export const AlignmentContainer = observer(AlignmentContainerComponent);
